import type { NextTemptation } from '../lib/story-graph-models.js';

type NextTemptationsProps = {
  fromName: string;
  temptations: readonly NextTemptation[];
  onChoose: (temptation: NextTemptation) => void;
};

function temptationHeading(kind: NextTemptation['kind']): string {
  switch (kind) {
    case 'recognizable-direct':
      return 'Closest recognizable connection';
    case 'two-hop-bridge':
      return 'Unexpected two-hop bridge';
    case 'unvisited-next-hop':
      return 'Keep following the story';
    case 'global-discovery':
      return 'Try general discovery';
  }
}

function temptationReason(temptation: NextTemptation, fromName: string): string {
  switch (temptation.reason.kind) {
    case 'documented-direct':
      return `${temptation.reason.relationshipLabel} · ${temptation.reason.lens === 'personal' ? 'Personal' : 'Family'}`;
    case 'different-domain':
      return `${fromName}: ${temptation.reason.fromDomain}; ${temptation.targetName}: ${temptation.reason.toDomain}`;
    case 'birth-year-gap':
      return `Born ${temptation.reason.yearsApart} years apart (${temptation.reason.fromBirthYear} and ${temptation.reason.toBirthYear})`;
    case 'global-fallback':
      return `No connection is implied; this is another recognizable person to explore.`;
  }
}

export function NextTemptations({ fromName, temptations, onChoose }: NextTemptationsProps) {
  if (temptations.length === 0) {
    return null;
  }

  return (
    <aside className="next-temptations" aria-label="Source-linked ideas for where to explore next">
      <div className="next-temptations__heading">
        <p className="eyebrow">Where next?</p>
        <p>Deterministic suggestions from this data snapshot.</p>
      </div>
      <ul>
        {temptations.map((temptation) => (
          <li key={`${temptation.kind}:${temptation.targetId}`}>
            <button type="button" onClick={() => onChoose(temptation)}>
              <small>{temptationHeading(temptation.kind)}</small>
              <strong>{temptation.targetName}</strong>
              <span>{temptationReason(temptation, fromName)}</span>
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}
